
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'duration': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M16.3636 0H1.63636C0.732273 0 0 0.732273 0 1.63636V16.3636C0 17.2677 0.732273 18 1.63636 18H16.3636C17.2677 18 18 17.2677 18 16.3636V1.63636C18 0.732273 17.2677 0 16.3636 0ZM15.3057 12.033L12.8512 14.4875C12.5313 14.8075 12.0134 14.8075 11.6943 14.4875C11.5347 14.328 11.4545 14.1185 11.4545 13.9091V12.2727H6.54545V13.9091C6.54545 14.1185 6.46527 14.328 6.30573 14.4875C5.98582 14.8075 5.46791 14.8075 5.14882 14.4875L2.69427 12.033C2.37436 11.7131 2.37436 11.1952 2.69427 10.8761L5.14882 8.42155C5.46873 8.10164 5.98664 8.10164 6.30573 8.42155C6.46527 8.58109 6.54545 8.79055 6.54545 9V10.6364H11.4545V9C11.4545 8.79055 11.5347 8.58109 11.6943 8.42155C12.0142 8.10164 12.5321 8.10164 12.8512 8.42155L15.3057 10.8761C15.6256 11.1952 15.6256 11.7139 15.3057 12.033ZM1.63636 4.90909H16.3636V1.63636H1.63636V4.90909Z" fill="#93A0AE"/>'
  }
})
